import { useMemo } from 'react';
import LocaleLink from 'components/link/LocaleLink';
import LaunchIcon from '@mui/icons-material/Launch';
import Typography from '@mui/material/Typography';

function CustomerLink({ customer }) {
  const name = useMemo(() => {
    return customer && (
      <LocaleLink href={`/customer/view?id=${customer.id}`}>
        <Typography variant='inherit' color='primary'>
          {customer.nameEng}
          {customer.nameEng && customer.nameChi && ' / '}
          {customer.nameChi}
          <LaunchIcon fontSize='small' className='ms-1' />
        </Typography>
      </LocaleLink>
    );
  }, [customer]);

  return (
    <div>
      {name}
    </div>
  );
}

CustomerLink.propTypes = {

};

export default CustomerLink;
